import React from 'react';
import { Route, Switch } from 'react-router-dom';
import loadable from '@loadable/component';
import { FourOhFourError } from '@sm/webassets';
import PageLoading from './components/PageLoading';

const Account = loadable(() => import(/* webpackChunkName: 'coreweb-account' */ './pages/account'), {
  fallback: <PageLoading />,
});

const Analysis = loadable(() => import(/* webpackChunkName: 'coreweb-analysis-base' */ './pages/analysis'), {
  fallback: <PageLoading />,
});

const PublishedDashboard = loadable(
  () => import(/* webpackChunkName: 'coreweb-dashboards' */ './pages/PublishedDashboard'),
  {
    fallback: <PageLoading />,
  }
);

const InstantResults = loadable(
  () => import(/* webpackChunkName: 'coreweb-instant-results' */ './pages/InstantResults'),
  {
    fallback: <PageLoading />,
  }
);

const LiveResults = loadable(() => import(/* webpackChunkName: 'coreweb-live-results' */ './pages/LiveResults'), {
  fallback: <PageLoading />,
});

const CrosstabReports = loadable(
  () => import(/* webpackChunkName: 'coreweb-crosstab-reports' */ './pages/CrosstabReports'),
  {
    fallback: <PageLoading />,
  }
);

const AudienceRouter = loadable(() => import(/* webpackChunkName: 'coreweb-audience' */ './pages/audience'), {
  fallback: <PageLoading />,
});

const Profile = loadable(() => import(/* webpackChunkName: 'coreweb-profile' */ './pages/profile'), {
  fallback: <PageLoading />,
});

const ProfilePortable = loadable(
  () => import(/* webpackChunkName: 'coreweb-profile-portable' */ './pages/ProfilePortable'),
  {
    fallback: <PageLoading />,
  }
);

const CreateSurvey = loadable(() => import(/* webpackChunkName: 'coreweb-create-survey' */ './pages/CreateSurvey'), {
  fallback: <PageLoading />,
});

const Solutions = loadable(() => import(/* webpackChunkName: 'coreweb-solutions' */ './pages/solutions'), {
  fallback: <PageLoading />,
});

const SharedTrackingSolution = loadable(
  () => import(/* webpackChunkName: 'coreweb-solutions' */ './pages/solutions/Tracking/Shared'),
  {
    fallback: <PageLoading />,
  }
);

const Team = loadable(
  () =>
    import(
      /* webpackChunkName: 'coreweb-team' */
      './pages/Team'
    ),
  {
    fallback: <PageLoading />,
  }
);

const User = loadable(() => import(/* webpackChunkName: 'coreweb-user' */ './pages/User'), {
  fallback: <PageLoading />,
});

const Billing = loadable(() => import(/* webpackChunkName: 'coreweb-billing' */ './pages/Billing'), {
  fallback: <PageLoading />,
});

const SurveysCore = loadable(() => import(/* webpackChunkName: 'coreweb-surveys-core' */ './pages/SurveysCore'), {
  fallback: <PageLoading />,
});

const SeatRequest = loadable(
  () => import(/* webpackChunkName: 'coreweb-seat-request' */ './pages/Team/ManageUsers/SeatRequest'),
  {
    fallback: <PageLoading />,
  }
);

const CoreCheckout = loadable(() => import(/* webpackChunkName: 'coreweb-checkout' */ './pages/Checkout'), {
  fallback: <PageLoading />,
});

const Home = loadable(() => import(/* webpackChunkName: 'coreweb-home' */ './pages/Home'), {
  fallback: <PageLoading />,
});

const BuyResponses = loadable(() => import(/* webpackChunkName: 'coreweb-responses' */ './pages/Responses'), {
  fallback: <PageLoading />,
});

const App = () => {
  return (
    <Switch>
      <Route path="/:page(summary|stories)/:encryptedSid">
        <SurveysCore />
      </Route>
      <Route path="/analyze" component={Analysis} />
      <Route path="/dashboards/:sharedKey" component={PublishedDashboard} />
      <Route path="/live/results" component={LiveResults} />
      <Route path="/results/:sharedViewKey/instant" component={InstantResults} />
      <Route path="/crosstabs" component={CrosstabReports} />
      <Route path="/collect/audience" component={AudienceRouter} />
      <Route path="/profile" exact component={Profile} />
      <Route path="/profile/portable" component={ProfilePortable} />
      <Route path="/profile/:profilePath" component={Profile} />
      <Route path="/create" component={CreateSurvey} />
      <Route path="/solutions/tracking/shared/:slug" component={SharedTrackingSolution} />
      <Route path="/market-research/solutions/get-started-2" component={Solutions} />
      <Route path="/solutions" component={Solutions} />
      <Route path="/team/users/seat_request" component={SeatRequest} />
      <Route path="/team" component={Team} />
      <Route path="/user/account/select" component={Account} />
      <Route path="/user" component={User} />
      <Route path="/:page(collect)/add">
        <SurveysCore />
      </Route>
      <Route path="/billing" component={Billing} />
      <Route path="/checkout" component={CoreCheckout} />
      <Route path="/new-home-page" component={Home} />
      <Route path="/buy-responses" component={BuyResponses} />
      {/* Catch all route */}
      <Route component={FourOhFourError} />
    </Switch>
  );
};

export default App;
